import InstitutionsService from "../../services/intitutions";
import { Speciality } from "../../services/speciality";

export const state = {
  errors: null,
  isLoading: false,
  isLoadingUnits: false,
  isLoadingSpecialties: false,
  institutions: [],
  institution: {},
  units: [],
  unitSpecialties: [],
  unitsOptions: [],
  unitSpecialtiesOptions: []
};

export const getters = {
  errors(state) {
    return state.errors;
  },
  isLoading(state) {
    return state.isLoading;
  },
  isLoadingUnits(state) {
    return state.isLoadingUnits;
  },
  isLoadingSpecialties(state) {
    return state.isLoadingSpecialties;
  },
  institutions(state) {
    return state.institutions;
  },
  institution(state) {
    return state.institution;
  },
  units(state) {
    return state.units;
  },
  unitSpecialties(state) {
    return state.unitSpecialties;
  },
  unitsOptions(state) {
    return state.unitsOptions;
  },
  unitSpecialtiesOptions(state) {
    return state.unitSpecialtiesOptions;
  }
};

export const mutations = {
  SET_ERRORS(state, payload) {
    state.errors = payload;
  },
  SET_IS_LOADING(state, payload) {
    state.isLoading = payload;
  },
  SET_IS_LOADING_UNITS(state, payload) {
    state.isLoadingUnits = payload;
  },
  SET_IS_LOADING_SPECIALTIES(state, payload) {
    state.isLoadingSpecialties = payload;
  },
  SET_INSTITUTIONS(state, payload) {
    state.institutions = payload;
  },
  SET_INSTITUTION(state, payload) {
    state.institution = payload;
  },
  SET_INSTITUTION_UNITS(state, payload) {
    state.units = payload;
  },
  SET_UNIT_SPECIALTIES(state, payload) {
    state.unitSpecialties = payload;
  },
  SET_UNITS_OPTIONS(state, payload) {
    const options = [{ label: "Escolha", value: null }];
    state.unitsOptions = options.concat(
      payload.map(unit => ({
        label: unit.name,
        value: unit.id
      }))
    );
  },
  SET_UNIT_SPECIALTIES_OPTIONS(state, payload) {
    const options = [{ label: "Escolha", value: null }];
    state.unitSpecialtiesOptions = options.concat(
      payload.map(specialty => ({
        label: specialty.name,
        value: specialty.id
      }))
    );
  }
};

export const actions = {
  async fetchInstitutions({ commit }, payload) {
    try {
      commit("SET_IS_LOADING", true);
      const response = await InstitutionsService.fetchInstitutions(payload);
      commit("SET_INSTITUTION", response.data);
      return response;
    } catch (error) {
      commit("SET_ERRORS", error);
    } finally {
      commit("SET_IS_LOADING", false);
    }
  },
  async fetchInstitution({ commit }, id) {
    try {
      commit("SET_IS_LOADING", true);
      const response = await InstitutionsService.fetchInstitution(id);
      commit("SET_INSTITUTION", response.data);
      return response;
    } catch (error) {
      commit("SET_ERRORS", error);
    } finally {
      commit("SET_IS_LOADING", false);
    }
  },
  async fetchInstitutionUnits({ commit }, id) {
    try {
      commit("SET_IS_LOADING_UNITS", true);
      const response = await InstitutionsService.fetchInstitutionUnits(id);
      commit("SET_INSTITUTION_UNITS", response.data);
      commit("SET_UNITS_OPTIONS", response.data);
      return response;
    } catch (error) {
      commit("SET_ERRORS", error);
    } finally {
      commit("SET_IS_LOADING_UNITS", false);
    }
  },
  async fetchInstitutionUnitSpecialties({ commit }, unitId) {
    try {
      commit("SET_IS_LOADING_SPECIALTIES", true);
      const response = await Speciality.byUnit(unitId);
      commit("SET_UNIT_SPECIALTIES", response.data);
      commit("SET_UNIT_SPECIALTIES_OPTIONS", response.data);
      return response;
    } catch (error) {
      commit("SET_ERRORS", error);
    } finally {
      commit("SET_IS_LOADING_SPECIALTIES", false);
    }
  }
};
